(function() {
    'use strict';

    angular.module('remitEventsApp').config(function($stateProvider) {
        $stateProvider
            .state('event', {
                parent: 'site',
                url: '/events/{commodity}/{contractor}',
                data: {
                    authorities: [],
                    pageTitle: 'remitEventsApp.event.home.title',
                    pageHeader: 'remitEventsApp.event.home.pageTitle'
                },
                params: {
                    contractor: null
                },
                views: {
                    content: {
                        templateUrl: function($stateParams) {
                            return 'scripts/app/entities/event/' + $stateParams.commodity + '/events.html';
                        },
                        controllerProvider: function($stateParams, Content) {
                            return Content.getEventController($stateParams.commodity);
                        },
                        controllerAs: 'event'
                    },
                    graph: {
                        templateUrl: function($stateParams) {
                            if ($stateParams.commodity === 'energy') {
                                return 'scripts/app/entities/event/' + $stateParams.commodity + '/graph.html';
                            }
                            return null;
                        },
                        controllerProvider: function($stateParams) {
                            if ($stateParams.commodity === 'energy') {
                                return 'GraphController';
                            }
                            return null;
                        },
                        controllerAs: 'graph'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('event');
                            $translatePartialLoader.addPart('mriEventType');
                            $translatePartialLoader.addPart('mriUnavailabilityType');
                            $translatePartialLoader.addPart('mriEventStatus');
                            $translatePartialLoader.addPart('mriMode');
                            $translatePartialLoader.addPart('mriFuelType');
                            $translatePartialLoader.addPart('mriMeasureUnit');
                            $translatePartialLoader.addPart('mriCommodity');
                            $translatePartialLoader.addPart('graph');

                            return $translate.refresh();
                        }
                    ]
                }
            })
            .state('event-others', {
                parent: 'site',
                url: '/events/other/{commodity}/{contractor}',
                params: {
                    contractor: 'all'
                },
                data: {
                    authorities: [],
                    otherEvents: true,
                    pageTitle: 'remitEventsApp.event.home.title',
                    pageHeader: {
                      type: 'check',
                      contractor: 'information',
                      then: 'remitEventsApp.event.home.otherTitle',
                      else: 'remitEventsApp.event.home.pageTitle'
                    }
                },
                views: {
                    content: {
                        templateUrl: 'scripts/app/entities/event/others/events.html',
                        controllerProvider: function(Content) {
                            return Content.getEventController('others');
                        },
                        controllerAs: 'event'
                    },
                    graph: {
                        templateUrl: null,
                        controllerProvider: null
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('event');
                            $translatePartialLoader.addPart('mriEventType');
                            $translatePartialLoader.addPart('mriUnavailabilityType');
                            $translatePartialLoader.addPart('mriEventStatus');
                            $translatePartialLoader.addPart('mriMode');
                            $translatePartialLoader.addPart('mriFuelType');
                            $translatePartialLoader.addPart('mriMeasureUnit');
                            $translatePartialLoader.addPart('mriCommodity');

                            return $translate.refresh();
                        }
                    ]
                }
            })
            .state('consumption-capacity', {
                parent: 'site',
                url: '/events/{commodity}/consumption/capacity',
                data: {
                    authorities: [],
                    otherEvents: true,
                    pageTitle: 'remitEventsApp.event.home.title',
                    pageHeader: 'remitEventsApp.event.home.consumptionCapacityTitle'
                },
                views: {
                    content: {
                        templateUrl: function($stateParams) {
                            return (
                                'scripts/app/entities/event/' + $stateParams.commodity + '/consumption-capacity/consumption-capacity.html'
                            );
                        },
                        controllerProvider: function($stateParams) {
                            return $stateParams.commodity === 'energy'
                                ? 'EnergyConsumptionCapacityController'
                                : 'GasConsumptionCapacityController';
                        },
                        controllerAs: 'capacity'
                    },
                    graph: {
                        templateUrl: null,
                        controllerProvider: null
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('event');
                            $translatePartialLoader.addPart('mriEventType');
                            $translatePartialLoader.addPart('mriUnavailabilityType');
                            $translatePartialLoader.addPart('mriEventStatus');
                            $translatePartialLoader.addPart('mriMode');
                            $translatePartialLoader.addPart('mriFuelType');
                            $translatePartialLoader.addPart('mriMeasureUnit');
                            $translatePartialLoader.addPart('mriCommodity');

                            return $translate.refresh();
                        }
                    ]
                }
            })
            .state('iframe', {
                parent: 'site',
                url: '/iframe/{commodity}',
                data: {
                    iframe: true,
                    authorities: [],
                    pageTitle: 'remitEventsApp.event.home.title'
                },
                views: {
                    'tabswrap@': {
                        templateUrl: function($stateParams) {
                            return 'scripts/app/entities/event/' + $stateParams.commodity + '/events.html';
                        },
                        controllerProvider: function($stateParams, Content) {
                            return Content.getEventController($stateParams.commodity);
                        },
                        controllerAs: 'event'
                    },
                    'iframegraph@': {
                        templateUrl: function($stateParams) {
                            if ($stateParams.commodity === 'energy') {
                                return 'scripts/app/entities/event/' + $stateParams.commodity + '/graph.html';
                            }
                            return null;
                        },
                        controllerProvider: function($stateParams) {
                            if ($stateParams.commodity === 'energy') {
                                return 'GraphController';
                            }
                            return null;
                        },
                        controllerAs: 'graph'
                    }
                },
                resolve: {
                    translatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('event');
                            $translatePartialLoader.addPart('mriEventType');
                            $translatePartialLoader.addPart('mriUnavailabilityType');
                            $translatePartialLoader.addPart('mriEventStatus');
                            $translatePartialLoader.addPart('mriMode');
                            $translatePartialLoader.addPart('mriFuelType');
                            $translatePartialLoader.addPart('mriMeasureUnit');
                            $translatePartialLoader.addPart('mriCommodity');
                            $translatePartialLoader.addPart('graph');
                            return $translate.refresh();
                        }
                    ]
                }
            })
            .state('iframe-other', {
                parent: 'site',
                url: '/iframe/other/{commodity}/{contractor}',
                params: {
                    contractor: 'all'
                },
                data: {
                    iframe: true,
                    authorities: [],
                    pageTitle: 'remitEventsApp.event.home.title'
                },
                views: {
                    'tabswrap@': {
                        templateUrl: 'scripts/app/entities/event/others/events.html',
                        controllerProvider: function(Content) {
                            return Content.getEventController('others');
                        },
                        controllerAs: 'event'
                    },
                    'iframegraph@': {
                        templateUrl: null,
                        controllerProvider: null
                    }
                },
                resolve: {
                    translatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('event');
                            $translatePartialLoader.addPart('mriEventType');
                            $translatePartialLoader.addPart('mriUnavailabilityType');
                            $translatePartialLoader.addPart('mriEventStatus');
                            $translatePartialLoader.addPart('mriMode');
                            $translatePartialLoader.addPart('mriFuelType');
                            $translatePartialLoader.addPart('mriMeasureUnit');
                            $translatePartialLoader.addPart('mriCommodity');
                            $translatePartialLoader.addPart('graph');
                            return $translate.refresh();
                        }
                    ]
                }
            })
            .state('event-versions', {
                parent: 'site',
                url: '/{contractor}/event/{commodity}/versions/{messageId}',
                data: {
                    authorities: [],
                    pageTitle: 'remitEventsApp.event.detail.title'
                },
                views: {
                    content: {
                        templateUrl: function($stateParams) {
                            return 'scripts/app/entities/event/' + $stateParams.commodity + '/event-detail.html';
                        },
                        controllerProvider: function($stateParams, Content) {
                            return Content.getEventDetailController($stateParams.commodity);
                        },
                        controllerAs: 'eventDetail'
                    }
                },
                resolve: {
                    translatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('event');
                            $translatePartialLoader.addPart('mriEventType');
                            $translatePartialLoader.addPart('mriUnavailabilityType');
                            $translatePartialLoader.addPart('mriEventStatus');
                            $translatePartialLoader.addPart('mriMode');
                            $translatePartialLoader.addPart('mriFuelType');
                            $translatePartialLoader.addPart('mriMeasureUnit');
                            $translatePartialLoader.addPart('mriCommodity');
                            return $translate.refresh();
                        }
                    ]
                }
            })
            .state('iframe-versions', {
                parent: 'site',
                url: '/iframe/{commodity}/versions/{messageId}',
                data: {
                    iframe: true,
                    authorities: [],
                    pageTitle: 'remitEventsApp.event.detail.title'
                },
                views: {
                    'tabswrap@': {
                        templateUrl: function($stateParams) {
                            return 'scripts/app/entities/event/' + $stateParams.commodity + '/event-detail.html';
                        },
                        controllerProvider: function($stateParams, Content) {
                            return Content.getEventDetailController($stateParams.commodity);
                        },
                        controllerAs: 'eventDetail'
                    }
                },
                resolve: {
                    translatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('event');
                            $translatePartialLoader.addPart('mriEventType');
                            $translatePartialLoader.addPart('mriUnavailabilityType');
                            $translatePartialLoader.addPart('mriEventStatus');
                            $translatePartialLoader.addPart('mriMode');
                            $translatePartialLoader.addPart('mriFuelType');
                            $translatePartialLoader.addPart('mriMeasureUnit');
                            $translatePartialLoader.addPart('mriCommodity');
                            return $translate.refresh();
                        }
                    ]
                }
            });
    });
})();
